<template>
  <div>
    <h1>Filtros</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar conductor"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
          <b-form-group v-slot="{ ariaDescribedby }" class="w-100 mb-0">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="selectedTypeFilter"
              @change="selectedTypeFilterUpdate"
              :aria-describedby="ariaDescribedby"
              name="flavour-2"
            >
              <b-table
                show-empty
                hover
                stacked="md"
                :items="arraySelected"
                :fields="fieldsDrivers"
                :current-page="currentPage"
                :per-page="perPage"
                class="mb-0 bg-white"
                empty-text="No existen registros por mostrar"
                emptyFilteredText="No existen registros por mostrar"
              >
              <template v-slot:cell(estado)="row">
                <b-form-checkbox :value="row.item.id">{{row.item.label}}</b-form-checkbox>
              </template>
              </b-table>
            </b-form-checkbox-group>
          </b-form-group>
      </b-col>
      <b-table
          show-empty
          stacked="md"
          :items="selectedTypeFilterObj"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          empty-text="No existen registros por mostrar"
          emptyFilteredText="No existen registros por mostrar"
        >
          <template v-slot:cell(actions)='row'>
            <b-button variant="success" size="md" @click="searchVehicle(row.item.driver.id)" class="mr-2">
              Ver en mapa
            </b-button>
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
    </b-row>
  </div>
</template>
<script>
import firebase from 'firebase'
import moment from 'moment'
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      icon:
        [
          'T1V.svg',
          'T1A.png',
          'T1R.png',
        ],
      fields: [
        { key: 'driver.id', label: 'Id' },
        { key: 'driver.firstName', label: 'Nombre(s)' },
        { key: 'driver.lastName', label: 'Apellidos' },
        { key: 'driver.license', label: 'Número de licencia' },
        { key: 'driver.cardId', label: 'Número de tarjetón' },
        { key: 'driver.email', label: 'Correo electrónico' },
        { key: 'driver.phoneNumber', label: 'Número de teléfono' },
        { key: 'concesion.vehicle.vehicleType.type', label: 'Tipo de vehículo' },
        { key: 'concesion.vehicle.licensePlate', label: 'Número de placa' },
        { key: 'concesion.vehicle.brand', label: 'Marca' },
        { key: 'concesion.vehicle.model', label: 'Modelo' },
        { key: 'actions', label: 'Acciones (Ver en mapa)' },
      ],
      totalEmergencyDrivers: 0,
      totalActiveDrivers: 0,
      totalInactiveDrivers: 0,
      totalOnTripDrivers: 0,
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      googleMapMarker: [],
      infoWindows: [],
      status: [],
      driverId: null,
      allDrivers: [],
      drivesrInZone: [],
      emergencyDrivers: [],
      activeDrivers: [],
      inactiveDrivers: [],
      onTripDrivers: [],
      mapzoom: null,
      colors: {
        inactive: '#5D716E',
        available: '#29D336',
        unavailable: '#FF0000',
        emergency: '#FF0000',
        tc: '#4B7CF3',
      },
      unsubscribe: null,
      driversFirebase: {},
      selectedTypeFilter: [],
      selectedTypeFilterObj: [],
      arraySelected: [
        { id: 'emergency', label: 'Emergencia' },
        { id: 'active', label: 'Activos' },
        { id: 'inactive', label: 'Inactivos' },
        { id: 'onTrip', label: 'En viaje' },
      ],
      filteredDrivers: [],
      fieldsDrivers: [
        // 'index',
        { key: 'estado', label: 'Filtrar por estado' },
      ],
    }
  },
  async mounted() {
    this.allDrivers = []
    await this.getDrivers() // Trae la información del firebase
    this.selectedTypeFilterObj = this.allDrivers
    this.updateMap()
    this.mapzoom = this.map.getZoom()
    const mapa = this.map
    const that = this
    this.google.maps.event.addListener(mapa, 'zoom_changed', function() {
      that.mapzoom = mapa.getZoom() // to stored the current zoom level of the map
      that.updateMap()
    })
    let changeCenter = true
    this.map.addListener('center_changed', () => {
      // 3 seconds after the center of the map has changed, pan back to the
      // marker.
      if (changeCenter) {
        changeCenter = false
        window.setTimeout(() => {
          changeCenter = true
          that.updateMap()
        }, 1000)
      }
    })
    this.unsubscribe = firebase
      .firestore()
      .collection('drivers')
      .onSnapshot(snapshot => {
        if (snapshot.docChanges()[0].type === 'modified') {
          snapshot.docChanges().forEach(document => {
            let driver = document.doc.data()
            driver = this.driverFormat(driver)
            this.changePosition(driver)
          })
        }
        /*
        else if (snapshot.docChanges()[0].type === 'added') {
          snapshot.docChanges().forEach(document => {
            const id = document.doc.id
            const driver = document.doc.data()
            const location = driver.location
            const position = new LatLng(location.position.geopoint.latitude, location.position.geopoint.longitude)
            const color = driver.active ? (driver.onTrip ? this.colors.unavailable : this.colors.available) : this.colors.inactive
            const symbol = {
              fillColor: color,
              scale: 0.5,
              rotation: location.heading,
            }
            const marker = new Marker({
              position: position,
              marker: driver,
              map: this.map,
              icon: symbol,
            })
            this.googleMapMarker[id] = marker
          })
        } */
      })
  },
  // eslint-disable-next-line vue/require-render-return
  render() {},
  methods: {
    async getDrivers() {
      const requestTime = moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
      await firebase.firestore().collection('drivers').get()
        .then(drivers => {
          drivers.forEach(driver => {
            const d = driver.data()
            const taxiCI = this.driverFormat(d)
            if (d.emergency === true) {
              this.emergencyDrivers.push(taxiCI)
            }
            if (d.active === true) {
              this.activeDrivers.push(taxiCI)
            } else {
              this.inactiveDrivers.push(taxiCI)
            }
            if (d.onTrip === true) {
              this.onTripDrivers.push(taxiCI)
            }
            this.allDrivers.push(taxiCI)
          })
          this.totalRows = this.allDrivers.length
          this.totalEmergencyDrivers = this.emergencyDrivers.length
          this.totalActiveDrivers = this.activeDrivers.length
          this.totalInactiveDrivers = this.inactiveDrivers.length
          this.totalOnTripDrivers = this.onTripDrivers.length
          const dataEmit = {
            totalRows: this.totalRows,
            totalEmergencyDrivers: this.totalEmergencyDrivers,
            totalActiveDrivers: this.totalActiveDrivers,
            totalInactiveDrivers: this.totalInactiveDrivers,
            totalOnTripDrivers: this.totalOnTripDrivers,
            requestTime: requestTime,
          }
          this.$emit('updatedInfo', dataEmit)
        })
        .catch(error => {
          console.log(error)
        })
    },
    selectedTypeFilterUpdate() {
      setTimeout(() => {
        this.selectedTypeFilterObj = []
        if (this.selectedTypeFilter.length < 1) {
          this.selectedTypeFilterObj = this.allDrivers
        } else {
          this.selectedTypeFilter.forEach(d => {
            if (d === 'emergency') {
              this.emergencyDrivers.forEach(i => {
                if (!this.selectedTypeFilterObj.includes(i)) {
                  this.selectedTypeFilterObj.push(i)
                }
              })
            }
            if (d === 'active') {
              this.activeDrivers.forEach(i => {
                if (!this.selectedTypeFilterObj.includes(i)) {
                  this.selectedTypeFilterObj.push(i)
                }
              })
            }
            if (d === 'inactive') {
              this.inactiveDrivers.forEach(i => {
                this.selectedTypeFilterObj.push(i)
              })
            }
            if (d === 'onTrip') {
              this.onTripDrivers.forEach(i => {
                this.selectedTypeFilterObj.push(i)
              })
            }
          })
        }
        this.updateMap()
      }, 50)
    },
    getDistance(centerPoint) {
      const km = 38000 / Math.pow(2, this.mapzoom - 3) * Math.cos(centerPoint.lat() * Math.PI / 180)
      const that = this
      const withInRange = this.selectedTypeFilterObj.filter(function (point) {
        if (that.googleMapMarker[point.driver.id]) {
          that.googleMapMarker[point.driver.id].setMap(that.map)
        }
        if (point.location !== null && point.location !== undefined) {
          // return this.arePointsNear(centerPoint, point.location.position.geopoint, distance)
          // (centerPoint.lng() - point.location.position.geopoint.longitude)
          var R = 3958.8 // Radius of the Earth in miles
          var rlat1 = centerPoint.lat() * (Math.PI / 180) // Convert degrees to radians
          var rlat2 = point.location.position.geopoint.latitude * (Math.PI / 180) // Convert degrees to radians
          var difflat = rlat2 - rlat1 // Radian difference (latitudes)
          var difflon = (point.location.position.geopoint.longitude - centerPoint.lng()) * (Math.PI / 180) // Radian difference (longitudes)
          var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)))
          return d <= km
        } else {
          return false
        }
      })
      return withInRange
    },
    updateMap() {
      this.googleMapMarker.forEach(function(m) {
        m.setMap(null)
      })
      this.drivesrInZone = this.getDistance(this.map.getCenter())
      this.drivesrInZone.forEach(driver => {
        this.changePosition(driver)
      })
    },
    searchVehicle(driverId) {
      const driver = this.selectedTypeFilterObj.filter(function (d) {
        return d.id === driverId
      })
      if (!this.googleMapMarker[driverId]) {
        this.changePosition(driver[0])
      }
      const marker = this.googleMapMarker[driverId]
      if (marker) {
        marker.icon.fillColor = this.colors.tc
        marker.icon.strokeColor = this.colors.tc
        this.map.panTo(marker.getPosition())
      }
    },
    changePosition(driver) {
      if (this.googleMapMarker[driver.driver.id]) {
        this.googleMapMarker[driver.driver.id].setMap(null)
      }
      this.addMarker(driver)
    },
    driverFormat(d) {
      const requestTime = moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
      return {
        id: d.driver.id,
        driver: d.driver !== undefined ? {
          id: d.driver.id,
          firstName: d.driver.firstName,
          lastName: d.driver.lastName,
          license: d.driver.license,
          cardId: d.driver.cardId,
          phoneNumber: d.driver.phoneNumber,
          email: d.driver.email,
        } : {},
        concesion: {
          id: 1,
          vehicle: (d.vehicle !== undefined && d.vehicle !== null) ? {
            id: d.vehicle.id,
            brand: d.vehicle.brand,
            licensePlate: d.vehicle.licensePlate,
            model: d.vehicle.model,
            serialNumber: d.vehicle.serialNumber,
            subBrand: d.vehicle.subBrand,
            vehicleType: {
              id: d.vehicle.vehicleType.id,
              chargeDiscount: d.vehicle.vehicleType.chargeDiscount,
              fare: d.vehicle.vehicleType.fare,
              type: d.vehicle.vehicleType.type,
            },
          } : {},
        },
        location: d.location,
        active: d.active,
        lastUpdate: requestTime,
        emergency: d.emergency,
      }
    },
    addMarker(driver) {
      const { Marker, LatLng, InfoWindow } = this.google.maps
      const id = driver.driver.id
      const location = driver.location
      if (location) {
        const vehicle = driver.concesion.vehicle
        const position = new LatLng(location.position.geopoint.latitude, location.position.geopoint.longitude)
        const color = driver.emergency ? this.colors.unavailable : (driver.active ? (driver.onTrip ? this.colors.unavailable : this.colors.available) : this.colors.inactive)
        const symbol = {
          path: 'M62.1,36.5c-0.9-1.2-3.6-1.5-3.6-1.5c0.1-3.5,0.5-6.9,0.7-8.2c1.9-7.3-1.7-11.8-1.7-11.8c-4.8-4.8-9.1-5-12.5-5   c-3.4,0-7.8,0.3-12.5,5c0,0-3.6,4.5-1.7,11.8c0.2,1.2,0.5,4.6,0.7,8.2c0,0-2.7,0.3-3.6,1.5c-0.9,1.2-0.9,1.9,0,1.9   c0.9,0,2.9-2.3,3.6-2.3V35c0,1,0.1,2,0.1,3c0,4.4,0,33.7,0,33.7s-0.3,6.1,5,7.8c1.2,0,4.6,0.4,8.4,0.5c3.8-0.1,7.3-0.5,8.4-0.5   c5.3-1.7,5-7.8,5-7.8s0-29.3,0-33.7c0-1,0-2,0.1-3v1.2c0.7,0,2.7,2.3,3.6,2.3C63,38.5,63,37.7,62.1,36.5z M34.7,66.5   c-0.3,3.3-2.3,4.1-2.3,4.1V37.4c0.8,1.2,2.3,6.8,2.3,6.8S34.9,63.2,34.7,66.5z M54.8,75.2c0,0-4.2,2.3-9.8,2.2   c-5.6,0.1-9.8-2.2-9.8-2.2v-2.8c4.9,2.2,9.8,2.2,9.8,2.2s4.9,0,9.8-2.2V75.2z M35.2,41.1l-1.7-10.2c0,0,4.5-3.2,11.5-3.2   s11.5,3.2,11.5,3.2l-1.7,10.2C51.4,39.2,38.6,39.2,35.2,41.1z M57.7,70.6c0,0-2.1-0.8-2.3-4.1c-0.3-3.3,0-22.4,0-22.4   s1.5-5.6,2.3-6.8V70.6z',
          fillColor: color,
          fillOpacity: 0.8,
          strokeColor: color,
          anchor: new this.google.maps.Point(45, 45),
          scale: 0.5,
          rotation: location.heading,
        }
        const marker = new Marker({
          position: position,
          marker: driver,
          map: this.map,
          icon: symbol,
          id: id,
        })
        this.googleMapMarker[id] = marker
        const infoWindow = new InfoWindow({
          disableAutoPan: true,
        })
        this.infoWindows[id] = infoWindow
        marker.addListener('click', () => {
          const content = `
                            <div class="ui header">Marca de vehículo: ${vehicle.brand}</div>
                            <div class="ui header">Modelo de vehículo: ${vehicle.model}</div>
                            <div class="ui header">Placa del vehículo: ${vehicle.licensePlate}</div>
                            <div class="ui header">Tipo de vehículo: ${vehicle.vehicleType.type}</div>
                            <div class="ui header">Nombre de conductor: ${driver.driver.firstName}</div>
                            <div class="ui header">Apellido de conductor: ${driver.driver.lastName}</div>
                            <div class="ui header">Emergencia: ${driver.emergency || false}</div>
                            `
          this.infoWindows[id].setContent(content)
          this.infoWindows[id].open(this.map, marker)
        })
      }
    },
    onFiltered(filteredItems) {
      this.filteredDrivers = filteredItems
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
  beforeDestroy() {
    this.unsubscribe()
    console.log('Component Destroyed')
  },
}
</script>
